import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import {
  ActivityCard,
  ActivityText,
  Avatar,
  DateLink,
  LoadMoreWrapper,
  NameLink,
  TimelineWrapper,
  TitleLink,
} from '@/common/timelineStyles';
import { usePagination } from '~/hooks/usePagination';
import { getPaginatedActivities } from '~/mockData';
import { WBSButton } from '~/modules/common/WBSButton';

export const Route = createFileRoute(
  '/_app/_users/members/$memberId/profile/timeline',
)({
  component: Timeline,
});

function Timeline() {
  const { t } = useTranslation();
  const { items, isLoading, hasMore, loadMore } = usePagination(
    getPaginatedActivities,
  );

  return (
    <Wrapper>
      {items.map((activity) => (
        <ActivityCard key={activity.id}>
          <Avatar src={activity.avatarUrl} alt={activity.studentName} />
          <ActivityText>
            <NameLink to="/profile">{activity.studentName}</NameLink>
            {/* Translation Needed */}
            {' has completed '}
            <TitleLink to="#">{activity.activityTitle}</TitleLink>
            {/* Translation Needed */}
            {' and is '}
            <span className="status">{activity.status}</span>
            <DateLink to="#">{activity.submittedDate}</DateLink>
          </ActivityText>
        </ActivityCard>
      ))}
      {hasMore && (
        <LoadMoreWrapper>
          <WBSButton wide onClick={loadMore} isLoading={isLoading} alternate>
            {t('wbs.load-more')}
          </WBSButton>
        </LoadMoreWrapper>
      )}
    </Wrapper>
  );
}

const Wrapper = styled(TimelineWrapper)`
  padding: 30px 2px 38px 53px;
`;
